import Store from './Store';

const SupplierStore = new Store('suppliers');

export {SupplierStore};